// extracted by mini-css-extract-plugin
export default {"error":"ErrorBoundary_error__znuaf","img":"ErrorBoundary_img__AIyJu","tip":"ErrorBoundary_tip__0rVvg"};